import { Routes } from '@angular/router';
import { ScopeGuard } from '../auth/services/scope.guard';
import { SCOPES } from 'src/app/app.constants';

export const SALES_REGISTERS_ROUTES: Routes = [
  { path: 'close', loadComponent: () => import('./components/register-close/register-close.component').then(m => m.RegisterCloseComponent), canActivate: [ScopeGuard], data: { scopes: [SCOPES.salesRegisters.close] } },
  { path: 'shifts/:id', loadComponent: () => import('./components/shift-view/shift-view.component').then(m => m.ShiftViewComponent), canActivate: [ScopeGuard], data: { scopes: [SCOPES.admin.sales.manage] } },
  { path: 'shifts', loadComponent: () => import('./components/shift-list/shift-list.component').then(m => m.ShiftListComponent), canActivate: [ScopeGuard], data: { scopes: [SCOPES.admin.sales.manage] } }
];
